import './styles/tokens.css';
import './styles/base.css';
import './styles/components.css';
import './styles/privacy.css';
import { header } from './components/header.js';
import { footer } from './components/footer.js';
import { initPromo } from './components/promo.js';
import { trackPageView, trackVisitRecency } from './lib/analytics.js';
import { aboutPage } from './components/info-pages.js';
import { initTheme } from './lib/theme.js';

initTheme();

document.getElementById('app').innerHTML = `
  ${header()}
  ${aboutPage()}
  ${footer()}
`;

initPromo();

// Every page reports its own view. Without this only the home page was counted,
// which made this page invisible AND quietly inflated nothing — the funnel's
// denominator was home-only while the house ad on this very page was reporting
// impressions (REL-071).
trackPageView('about');
trackVisitRecency();

if ('serviceWorker' in navigator && import.meta.env.PROD) {
  addEventListener('load', () => navigator.serviceWorker.register('/service-worker.js').catch(() => {}));
}
